import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { CashReceiptEnums } from 'src/app/enum/cash-receipt-enums';
import { WindowEnums } from 'src/app/enum/window-enums';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { CashReceiptPrintModel } from 'src/app/models/print/wallet/cash-receipt-print.model';
import { CashReceiptModel } from 'src/app/models/wallet/cash-receipt.model';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { EnterpriseService } from 'src/app/services/management/enterprise.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CashReceiptService } from 'src/app/services/wallet/cash-receipt.service';
import { CashReceiptPrintingRangeComponent } from '../cash-receipt-printing-range/cash-receipt-printing-range.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { Popover } from 'primeng/popover';
import { HttpEventType } from '@angular/common/http';
import { CompanyService } from 'src/app/services/management/company.service';
import { CashReceiptImportModel } from 'src/app/models/imports/cash-receipt-import.model';
import readXlsxFile from 'read-excel-file';
import moment from 'moment';
import { BussinessDocumentsClassEnums } from 'src/app/enum/bussiness-documets-class-enums';
import { IncomeConceptEnum } from 'src/app/enum/income-concept-enums';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';

@Component({
  selector: 'app-cash-receipt-import',
  templateUrl: './cash-receipt-import.component.html',
  styleUrls: ['./cash-receipt-import.component.scss'],
  standalone: false
})
export class CashReceiptImportComponent implements OnInit {

  @ViewChild('printingRangeModal') printingRangeModalComponent?: CustomModalComponent | null = null;
  @ViewChild('information') informationPopover!: Popover;

  formImport: FormGroup = new FormGroup({});
  accountingInterfaceCode: string = "";
  branchId: number = 0;
  branchCode: number | null = null;
  cashReceiptsAlerts: Array<PreInvoicingAlertModel> = new Array<PreInvoicingAlertModel>;
  cashReceiptId: number = 0;
  cashReceiptContract: CashReceiptModel = new CashReceiptModel();
  cashReceiptsPrintModel: Array<CashReceiptPrintModel> = new Array<CashReceiptPrintModel>;
  cashReceiptStateOpen = CashReceiptEnums.abierto;
  cashReceiptStateString: string = 'Anulado';
  clientId: number = 0;
  codeCurrency: string = "";
  companyCashReceiptQuantity: number = 0;
  companyId: number | null = null;
  companyCode: number | null = null;
  costCenterId: number = 0;
  disabledDetail: boolean = true;
  disabledForm: boolean = false;
  enterpriseId: number = 0;
  enterpriseCode: number | null = null;
  eventFile: any;
  errorCashReceipts: number = 0;
  iconStateCashReceipt: string = 'pi pi-lock-open';
  inputsForPrintingRangeModals$ = new BehaviorSubject<any>({
    consecutiveCashReceipt: 0
  });
  isChargeAccount: boolean = false;
  isOpened: string | undefined = undefined;
  incomeConceptCode: number = 0;
  listArticles: any[] = [];
  listClasses: any[] = [
    { label: "Facturas", value: 1 },
    { label: "Cuentas Cobro", value: 6 }
  ];
  listConceptsInvoicing: any[] = [];
  listBranches: any[] = [];
  listEnterprises: any[] = [];
  listCompanies: any[] = [];
  listIncomeConcept: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = 'Ningún archivo seleccionado.';
  nameWindow: string = "Importación de Recibos de Caja";
  openCashReceiptQuantity: number = 0;
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  quantityAdvancePayments: number = 0;
  quantityDetails: number = 0;
  quantityPayments: number = 0;
  selectedFile: File | null = null;
  showAccordionAdvancePayments: boolean = false;
  showAccordionDetail: boolean = false;
  showAccordionPayment: boolean = false;
  stateClientId: number | null = 0;
  titleStateCashReceipt: string = 'Cerrar';
  updateAdvances: boolean = false;
  url: string = "";
  userAuthenticated: UserModel = new UserModel();
  visibleSelectInvoice: boolean = true;
  visibleTxt: boolean = false;
  componentPrintingRangeModal = CashReceiptPrintingRangeComponent;

  constructor(
    private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private companyService: CompanyService,
    private cashReceiptService: CashReceiptService,
    private enterpriseService: EnterpriseService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) {
    this.getCompanies();
  }

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  async ngOnInit() {
    this.validateForm();
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.cashReceiptId = Object.keys(params).length > 0 ? params?.id : null;
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  openToggle(event: any) {
    this.informationPopover.toggle(event);
  }

  downloadErrorsTxt() {
    if (!this.cashReceiptsAlerts || this.cashReceiptsAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar');
      return;
    }

    this.cashReceiptService.exportImportErrors(this.cashReceiptsAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionRecibosDeCaja_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.cashReceiptService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaRecibosCaja.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  async getBranch(branchId: number) {
    if (branchId != null && branchId != 0) {
      this.branchId = branchId;
      const branch = this.listBranches.find(x => x.value == branchId);
      this.branchCode = branch.code;
      this.listEnterprises = await firstValueFrom(this.enterpriseService.getEnterprisesByBranchIdForSelect(this.branchId));
    } else {
      this.branchCode = null;
      this.branchId = 0;
      this.listEnterprises = [];
    }
  }

  async getCompanies() {
    try {
      const [companies] = await Promise.all([
        firstValueFrom(this.companyService.getAllCompaniesForSelectAsync()),
      ]);
      this.listCompanies = companies;
      return true;
    } catch (error) {
      console.error('Error al obtener las listas.', error);
      return false;
    }
  }

  async getCompany(companyId: number | null) {
    if (companyId != null && companyId != 0) {
      this.companyId = companyId;
      const company = this.listCompanies.find(x => x.value == companyId);
      this.companyCode = company.code;
      this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
    } else {
      this.companyId = null;
      this.companyCode = null;
      this.listBranches = [];
      this.listEnterprises = [];
      this.listArticles = [];
      this.listConceptsInvoicing = [];
      this.validateForm();
    }
  }

  async getEnterprise(enterpriseId: number | null) {
    if (enterpriseId != null && enterpriseId != 0) {
      this.enterpriseId = enterpriseId;
      const enterprise = this.listEnterprises.find(x => x.value == enterpriseId);
      this.enterpriseCode = enterprise.code;
    } else {
      this.enterpriseId = 0;
      this.companyCode = null;
    }
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      if (!response.branchId) {
        this.branchId = 0;
        return;
      }
      this.branchId = response.branchId;
      this.companyId = response.companyId;
      await this.getFirstEnterpriseByBranch();
    } catch (error) {
      this.branchId = 0;
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getFirstEnterpriseByBranch() {
    try {
      const response = await firstValueFrom(this.enterpriseService.getFirstEnterpriseByBranch(this.branchId));
      if (!response) {
        this.enterpriseId = 0;
        this.toastHandlerService.showToast('error', 'La Sucursal no tiene Empresas creadas.');
        return;
      };
      this.enterpriseId = response.enterpriseId;
    } catch (error) {
      console.error("Error al obtener la primera empresa de la sucursal: ", error);
    }
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'warning',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    this.isChargeAccount = !url.startsWith('cash-receipt/register');
    try {
      await this.getPermissionProfileByUrl();
      this.getPermissionsForUserByWindow();
      this.getPermissionPrint();
    } catch (error) {
      console.error('Error al obtener los permisos del perfil por URL.', error);
    }
  }

  async getPermissionsForUserByWindow() {
    this.userAuthenticated = await firstValueFrom(this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0)));
    if (this.isChargeAccount) {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceiptChargeAccount));
      this.companyId = this.userAuthenticated.companyId;
    } else {
      this.permissionsUser = await firstValueFrom(this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CashReceipt));
      this.companyId = this.userAuthenticated.companyId;
    }
  }

  async getPermissionPrint() {
    try {
      this.permissionPrint = await firstValueFrom(this.cashReceiptService.getPermissionPrint());
    } catch (error) {
      console.error('Error al obtener los permisos de impresión.', error);
    }
  }

  async getPermissionProfileByUrl() {
    try {
      const baseUrl = this.url.split('/')[0];
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(baseUrl));
      if (!this.permissionUpdatable) {
        this.disabledDetail = true;
        this.disabledForm = true;
        setTimeout(() => this.formImport.disable());
      }
    } catch (error) {
      this.permissionUpdatable = false;
      console.error('Error al obtener el permiso actualizable por URL.', error);
    }
  }

  importCashReceipts() {
    this.cashReceiptsAlerts = [];
    this.errorCashReceipts = 0;
    this.visibleTxt = false;
    if (this.formImport.valid) {
      let isOk: boolean = true;
      const input = document.getElementById("fileImport") as any;
      const rowsImports = new Array<CashReceiptImportModel>();
      let row: CashReceiptImportModel;
      let counter: number = 1, bussinessDocumentsClassId: number,
        consecutive: number, isChargeAccount: boolean, dateCashReceipt: Date, clientDocument: string, clientDocument2: string,
        incomeConceptCode: number, description: string | null, observation: string | null, totalValue: number, otherValues: number, appliedValue: number,
        refundValue: number, utilizationValue: number, interestValue: number, commissionValue: number, bussinessDocumentsTypeCode: number | null,
        invoiceConsecutive: number | null, reteFuenteValue: number | null, reteIVAValue: number | null, reteICAValue: number | null,
        otherTaxes: number | null, discountValue: number | null, paidValue: number | null, wayToPay: number, valueWayToPay: number;
      if (input.files[0]) {
        readXlsxFile(input.files[0]).then(async (rows) => {
          if (rows.length <= 1) {
            this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar`);
            return;
          }
          rows.splice(0, 1);

          bussinessDocumentsClassId = this.formImport.get("bussinessDocumentsClassId")?.value;
          isChargeAccount = bussinessDocumentsClassId == BussinessDocumentsClassEnums.cuentaCobro;

          rows.forEach(element => {
            counter = counter + 1;
            let rowHasError = false;

            //A. Código Compañía:
            const companyCode = parseFloat(element[0] as string);
            if (isNaN(companyCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna A, Fila ${counter}. El código de la compañía no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }
            if (companyCode != this.companyCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna A, Fila ${counter}. La compañía del archivo no es igual a la compañía seleccionada.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //B. Código Sucursal:
            const branchCode = parseFloat(element[1] as string);
            if (isNaN(branchCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna B, Fila ${counter}. El código de la sucursal no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }
            if (branchCode != this.branchCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna B, Fila ${counter}. La sucursal del archivo no es igual a la sucursal seleccionada.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //C. Código Empresa:
            const enterpriseCode = parseFloat(element[2] as string);
            if (isNaN(enterpriseCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna C, Fila ${counter}. El código de la empresa no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }
            if (enterpriseCode != this.enterpriseCode) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna C, Fila ${counter}. La empresa del archivo no es igual a la empresa seleccionada.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //D. Consecutivo de recibo:
            consecutive = parseFloat(element[3] as string);
            if (isNaN(consecutive)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna D, Fila ${counter}. El número de recibo no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //E. Fecha:
            const dateCashReceiptString = element[4] as string;
            if (dateCashReceiptString == null || dateCashReceiptString == "") {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna E, Fila ${counter}. El campo de fecha recibo es obligatorio.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }
            //Convierte fecha de string a Date
            dateCashReceipt = moment(dateCashReceiptString, 'DD/MM/YYYY').toDate();
            if (!moment(dateCashReceiptString, 'DD/MM/YYYY').isValid()) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna E, Fila ${counter}. El campo de fecha recibo no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            // F. Documento Cliente:
            clientDocument = element[5] as string;
            if (clientDocument == null) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna F, Fila ${counter}. El documento del cliente no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            } else if (clientDocument.length > 15) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna F, Fila ${counter}. El documento del cliente supera el tamaño máximo de caracteres (15)`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            // G. Documento2 Cliente:
            clientDocument2 = element[6] as string;
            if (clientDocument2 != null && clientDocument2.length > 15) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna G, Fila ${counter}. El documento 2 del cliente supera el tamaño máximo de caracteres (15).`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //H. Concepto ingreso:
            incomeConceptCode = parseFloat(element[7] as string);
            if (isNaN(incomeConceptCode)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna H, Fila ${counter}. El concepto ingreso no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            // I. Descripcion:       
            description = element[8] as string;
            if (description != null && description.length > 320) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna I, Fila ${counter}. La descripción supera el tamaño máximo de caracteres (320).`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //J. Observación:
            observation = element[9] as string;
            if (observation != null && observation.length > 250) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna J, Fila ${counter}. La observación supera el tamaño máximo de caracteres (250).`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //K. Valor ingreso:
            totalValue = parseFloat(element[10] as string);
            if (isNaN(totalValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna K, Fila ${counter}. El valor ingreso no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //L. Otros valores:
            otherValues = parseFloat(element[11] as string);
            if (isNaN(otherValues)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna L, Fila ${counter}. Otros valores no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //M. Valor aplicado:
            appliedValue = parseFloat(element[12] as string);
            if (isNaN(appliedValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna M, Fila ${counter}. Valor aplicado no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //N. Reembolso:
            refundValue = parseFloat(element[13] as string);
            if (isNaN(refundValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna N, Fila ${counter}. Reembolso no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //O. Valor aprovechamiento:
            utilizationValue = parseFloat(element[14] as string);
            if (isNaN(utilizationValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna O, Fila ${counter}. Valor aprovechamiento no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //P. Valor interés:
            interestValue = parseFloat(element[15] as string);
            if (isNaN(interestValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna P, Fila ${counter}. Valor intereses no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //Q. Valor Comisión:
            commissionValue = parseFloat(element[16] as string);
            if (isNaN(commissionValue)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna Q, Fila ${counter}. Valor comisión no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //R. Forma de Pago:
            wayToPay = parseFloat(element[17] as string);
            if (isNaN(wayToPay)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna R, Fila ${counter}. Forma de pago no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            //S. Valor Forma de Pago:
            valueWayToPay = parseFloat(element[18] as string);
            if (isNaN(valueWayToPay)) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Columna S, Fila ${counter}. Valor Forma de pago no es válido.`;
              this.cashReceiptsAlerts.push(alert);
              rowHasError = true;
            }

            if (incomeConceptCode == IncomeConceptEnum.pagoFacturas) {
              //T. Tipo documento comercial:
              bussinessDocumentsTypeCode = parseFloat(element[19] as string);
              if (isNaN(bussinessDocumentsTypeCode)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Columna T, Fila ${counter}. El tipo de documento comercial no es válido.`;
                this.cashReceiptsAlerts.push(alert);
                rowHasError = true;
              }

              //U. Consecutivo:
              invoiceConsecutive = parseFloat(element[20] as string);
              if (isNaN(invoiceConsecutive)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Columna U, Fila ${counter}. El consecutivo de la factura no es válido.`;
                this.cashReceiptsAlerts.push(alert);
                rowHasError = true;
              }

              //V. Valor reteFuente:
              reteFuenteValue = parseFloat(element[21] as string);
              if (isNaN(reteFuenteValue)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Columna V, Fila ${counter}. Valor retefuente no es válido.`;
                this.cashReceiptsAlerts.push(alert);
                rowHasError = true;
              }

              //W. Valor reteIVA:
              reteIVAValue = parseFloat(element[22] as string);
              if (isNaN(reteIVAValue)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Columna W, Fila ${counter}. Valor reteiva no es válido.`;
                this.cashReceiptsAlerts.push(alert);
                rowHasError = true;
              }

              //X. Valor reteICA:
              reteICAValue = parseFloat(element[23] as string);
              if (isNaN(reteICAValue)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Columna X, Fila ${counter}. Valor reteica no es válido.`;
                this.cashReceiptsAlerts.push(alert);
                rowHasError = true;
              }

              //Y. Otros impuestos:
              otherTaxes = parseFloat(element[24] as string);
              if (isNaN(otherTaxes)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Columna Y, Fila ${counter}. Valor otros impuestos no es válido.`;
                this.cashReceiptsAlerts.push(alert);
                rowHasError = true;
              }

              //Z. Valor descuento:
              discountValue = parseFloat(element[25] as string);
              if (isNaN(discountValue)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Columna Z, Fila ${counter}. Valor descuento no es válido.`;
                this.cashReceiptsAlerts.push(alert);
                rowHasError = true;
              }

              //AA. Valor pagado:
              paidValue = parseFloat(element[26] as string);
              if (isNaN(paidValue)) {
                const alert = new PreInvoicingAlertModel();
                alert.alertType = 1;
                alert.message = `Columna AA, Fila ${counter}. Valor pagado no es válido.`;
                this.cashReceiptsAlerts.push(alert);
                rowHasError = true;
              }
            } else {
              bussinessDocumentsTypeCode = null;
              invoiceConsecutive = null;
              reteFuenteValue = null;
              reteIVAValue = null;
              reteICAValue = null;
              otherTaxes = null;
              discountValue = null;
              paidValue = null
            }

            if (!rowHasError) {
              row = new CashReceiptImportModel(counter, this.companyId!, this.branchId, this.enterpriseId, consecutive, isChargeAccount,
                dateCashReceipt, clientDocument, clientDocument2, incomeConceptCode, description, observation,
                totalValue, otherValues, appliedValue, refundValue, utilizationValue, interestValue, commissionValue, wayToPay, valueWayToPay, bussinessDocumentsClassId,
                bussinessDocumentsTypeCode, invoiceConsecutive, reteFuenteValue, reteIVAValue, reteICAValue, otherTaxes, discountValue, paidValue,);
              rowsImports.push(row);
            } else {
              isOk = false;
            }
          });

          if (isOk && rowsImports.length > 0) {
            try {
              const response = await firstValueFrom(this.cashReceiptService.importCashReceipts(rowsImports));
              this.loadPreInvoicingModel = response;
              this.cashReceiptsAlerts = response?.alerts ?? [];
              this.errorCashReceipts = response?.preInvoicingStateId;

              if (this.errorCashReceipts === 1) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast(
                  'error',
                  'La importación terminó con errores, puede exportarlos si lo desea.',
                  'ERROR');
              } else if (this.cashReceiptsAlerts.length > 0) {
                this.visibleTxt = true;
                this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
              } else {
                this.visibleTxt = false;
                this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
              }
              this.clearInputFile();
            } catch (error) {
              this.nameFile = 'Ningún archivo seleccionado.';
              console.error('Error al importar Recibos de caja.', error);
            }
          } else {
            this.errorCashReceipts = 1;
            this.visibleTxt = true;
            this.toastHandlerService.showToast(
              'error',
              'La importación terminó con errores, puede exportarlos si lo desea'
            );
          }
        });
      } else {
        this.toastHandlerService.showToast('warning', `No ha seleccionado ningún archivo.`);
      }
    } else {
      this.showValidationMessages();
    }
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatiria.',
      },
      branchId: {
        required: 'La sucursal es obligatoria.',
        min: 'La sucursal es obligatoria.'
      },
      enterpriseId: {
        required: 'La empresa es obligatoria.',
        min: 'La empresa es obligatoria.'
      },
      bussinessDocumentsClassId: {
        required: 'La clase es obligatoria.',
        min: 'La clase es obligatoria.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
      branchId: [0, [Validators.required, Validators.min(1)]],
      enterpriseId: [0, [Validators.required, Validators.min(1)]],
      bussinessDocumentsClassId: [1, [Validators.required]]
    });
  }
}


